import { inject, Injectable } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { NotificationDetailDto } from '../../../../../models/ts/notification-detail-dto.model';
import { HeaderNotificationDetailModalComponent } from '../../../components/modals/header/header-notification-detail/header-notification-detail-modal.component';
import { HeaderNotificationDetailModalData } from '../../../components/modals/header/header-notification-detail/header-notification-detail-modal-data';
import { headerNotificationsActions } from '../../../../store/features/header-notifications/header-notifications-actions';
import { HeaderPopupBaseService } from '../header-popup-base-service';
import { NotificationApiService } from '../../../../api/bizzmine/notification/notification-api.service';
import { take } from 'rxjs';
import { NotificationPopUpDto } from 'src/models/ts/notification-pop-up-dto.model';
import { ReadType } from 'src/models/ts/read-type.model';
import { refreshActions } from 'src/app/store/features/refresh/refresh-actions';

//TODO: this service is also used for opening notifications with detail-button in notifications-overview

/**
 * Header Notification Service is used for handling the opening of notification detail component.
 */

@Injectable({
  providedIn: 'root'
})
export class HeaderNotificationsService extends HeaderPopupBaseService {

  protected fetchAction = headerNotificationsActions.fetchNotifications();
  private notificationApiService = inject(NotificationApiService);
  private dialog = inject(Dialog);

  public openNotification(notification: NotificationPopUpDto): void {
    this.notificationApiService.getNotification(notification.ID).pipe(take(1)).subscribe({
      next: notificationDetail => {
        const dialogRef = this.dialog.open<NotificationDetailDto>(HeaderNotificationDetailModalComponent, { data: { notificationDetail: notificationDetail } as HeaderNotificationDetailModalData });

        dialogRef.closed.subscribe({
          next: () => {
            if (notification.Read == ReadType.Unread) {
              this.readNotification(notificationDetail.ID);
              this.refreshNotifications();
              this.store$.dispatch(refreshActions.refreshNotifications());
            }
          }
        });
      }
    });
  }

  public readNotification(id: number): void {
    this.store$.dispatch(headerNotificationsActions.readNotification({ id }));
  }

  public refreshNotifications(): void {
    this.store$.dispatch(headerNotificationsActions.fetchNotifications());
  }
}
